import { ReactNode, useEffect } from 'react';
import { NotificationContext, useNotificationProvider } from '@/hooks/use-notifications';
import { useAuth } from '@/hooks/use-auth';

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const { user } = useAuth();
  const { notifications, fetchNotifications, clearNotifications, markAsRead } =
    useNotificationProvider();

  useEffect(() => {
    if (user) {
      void fetchNotifications();
    } else {
      clearNotifications();
    }
  }, [user, fetchNotifications, clearNotifications]);

  return (
    <NotificationContext.Provider
      value={{ notifications, fetchNotifications, clearNotifications, markAsRead }}
    >
      {children}
    </NotificationContext.Provider>
  );
}
